// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file mlops/gauge_metric/gaugemetric.proto (package gauge_metric, syntax proto3)
/* eslint-disable */

import type { JsonObject } from "@bufbuild/protobuf";
import { RPC } from "../../runtime";

/**
 * @generated from message gauge_metric.GaugeMetricEventsRequest
 */
export type GaugeMetricEventsRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * IANA timezone name (e.g. "Asia/Colombo"). The daily buckets in the response follow it, so
 * DST transitions inside the range are handled correctly and the days stay right even when no
 * dates are sent. Falls back to the fixed offset carried by start_date when empty.
 *
 * @generated from field: string timezone = 4;
 */
timezone?: string;
/**
 * @generated from field: gauge_metric.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message gauge_metric.GaugeMetricEventsResponse
 */
export type GaugeMetricEventsResponse = {
/**
 * @generated from field: map<string, google.protobuf.Struct> data = 1;
 */
data?: { [key: string]: JsonObject };
}
;
/**
 * @generated from message gauge_metric.GaugeMetricDailyStatRequest
 */
export type GaugeMetricDailyStatRequest = {
/**
 * @generated from field: string date = 1;
 */
date?: string;
}
;
/**
 * @generated from message gauge_metric.GaugeMetricDailyStatResponse
 */
export type GaugeMetricDailyStatResponse = {
/**
 * @generated from field: map<string, int32> stats = 1;
 */
stats?: { [key: string]: number };
}
;
/**
 * @generated from message gauge_metric.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc gauge_metric.MlopsGaugeMetricService.GetMlopsGaugeMetricTotalCount
 */
export const MlopsGaugeMetricService_GetMlopsGaugeMetricTotalCount = new RPC<GaugeMetricEventsRequest,GaugeMetricEventsResponse>("POST", "/getMlopsGaugeMetricTotalCount");
/**
 * @generated from rpc gauge_metric.MlopsGaugeMetricService.GetGaugeMetricDailyStats
 */
export const MlopsGaugeMetricService_GetGaugeMetricDailyStats = new RPC<GaugeMetricDailyStatRequest,GaugeMetricDailyStatResponse>("GET", "/getGaugeMetricDailyStats");
